<template>
  <div id="OnTheGoCheckout">
    <div class="menu-box" >
      <div class="mx-auto w-1/2">
        <h2 class="menu-title text-3xl my-3 text-center">You just got a Bark Badge!</h2>
        <h2 class="menu-title text-xl my-3 text-center">Bark Badge &times; {{partner_id}}</h2>
      </div>
      <p class="text-grey-200">
        Bark Badge partners with shelters all around the country and this our <em>"on-the-go" checkout</em> technology!</p>
        <h1 class="font-bold ">How it works</h1>

        <ul class="how-to-list">
          <li class="my-3">Scan the badge "You already scanned the badge so it is already in your cart"</li>
          <li class="my-3">If you want to add more badges,
              <strike>you can enter the number in the input</strike>
              *you can scan them with your phone and they'll be added to your cart as long as you keep the same browser session open*
            </li>
          <li class="my-3">Then you simply add your pamyent info</li>
          <li class="my-3">Boom! The tags are activated and you will recieve an email confirmation of your purchase!</li>
        </ul>

        <div class="bg-green-200 text-green-600 py-3 px-2">
          15% of all purchases through Bark Badge On-The-Go Checkout are INSTANTLY donated directly to our charity partners whom you purchased the device from! ❤️
        </div>

        <p class="text-2xl font-bold my-10 text-center mx-auto">SALES THROUGH BARK BADGE ON-THE-GO CHECKOUT ARE NON-REFUNDABLE! NO EXCEPTIONS</p>

    </div>

    <!-- breadcrumbs -->
    <!-- <div class="flex ">
      <div class="bg-white shadow mx-2 py-3 bordr rounded">Cart</div>
      <div class="bg-white shadow mx-2 py-3 bordr rounded">Checkout</div>
    </div> -->
    <section>
      <Cart v-if="tab == 0" @changeTab="changeTab"/>
      <CardPayment v-if="tab == 1" @changeTab="changeTab" :cart="cart" @saleMade="saleMade"/>
      <ConfirmationReceipt v-if="tab == 2"/>
    </section>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import Cart from '@/petprofile/checkout/Cart.vue'
import CardPayment from '@/petprofile/checkout/CardPayment.vue'
import ConfirmationReceipt from '@/petprofile/checkout/ConfirmationReceipt.vue'
  export default{
    name: 'OnTheGoCheckout',
    components:{
      Cart,
      CardPayment,
      ConfirmationReceipt
    },
    data(){
      return{
        tab: 0,
      }
    },
    methods:{
      menuActions(link){
        window.open(link)
      },
      saleMade(){
        console.log('sale made triggered')
        this.changeTab(2)
      },
      changeTab(tab){
        this.tab = tab
      }
    },
    computed:{
      ...mapState(['cart', 'partner_id'])
    },
    created(){
    }
  }
</script>
<style scoped>
#OnTheGoCheckout{
  margin: auto;
  padding: 1rem;
  max-width: 900px;
  background-color: #fff;
  min-height: 90vh;
  position: relative;
  padding-bottom: 10rem;
}
.menu-box{
  width: 80%;
  margin: .5rem auto;
}
.temp-product{
  width: 80%;
  margin: 2rem auto;
}

.menu-item-bar{
  background-color: #fff;
  border-radius: 10px;
  width: 90%;
  max-width: 600px;
  font-size: 1rem;
  display: flex;
  /* flex-direction: row; */
  justify-content: space-between;
  align-items: center;
  margin: .5rem auto;
  transition: 1s;
  padding: .6rem;
  cursor:pointer;
}
.menu-item-bar:hover{
  transform: translateY(-10px);
}
.how-to-list{
  margin: 2rem 0;
  margin-left: 2rem;
}
.img-container{
  width: 1.4rem;
  height: 1.4rem;
  padding: .5rem;
  margin-right: 1.5rem;
  background-color: transparent;
  transition:1s;
}
.icon-text{
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.icon-text img{
  width: 1.8rem;
  height: 1.8rem;
}
.menu-title{
  color: var(--primary);
}
</style>
